import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
	fetchAttachments as fetchAttachmentsAction,
	fetchProduct as fetchProductAction,
	fetchProductMindItems as fetchProductMindItemsAction,
} from '../../actions/product.actions';
import AttachmentsContent from '../../components/AttachmentsContent';
import { routes } from '../../constants';
import { selectUser } from '../../reducers/user.selectors';
import useAction from '../../utils/useAction';
import useRouter from '../../utils/useRouter';

const ProductAttachmentsPage: React.FC = () => {
	const {
		router,
		match: {
			params: { productId },
		},
	} = useRouter();
	const fetchProduct = useAction(fetchProductAction);
	const fetchProductMindItems = useAction(fetchProductMindItemsAction);
	const fetchAttachments = useAction(fetchAttachmentsAction);
	const user = useSelector(selectUser);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	useEffect(() => {
		fetchProduct(productId);
		fetchProductMindItems(productId);
		fetchAttachments(productId);
	}, [productId]);

	useEffect(() => {
		if (user && !user.hasDocumentLevelAccess) {
			router.replace(`/${routes.productPage.root}/${productId}`);
		}
	}, [productId, router, user]);

	if (user && !user.hasDocumentLevelAccess) {
		return <></>;
	}

	return <AttachmentsContent />;
};

export default ProductAttachmentsPage;
